import {api} from './../../../system/api';

export default {
    packingPackage: (params) => api.post('bags/' + params.id + '/bag-packings', {...params}, {singleRequest: false}),
    updateWeightReal: (params) => api.out('bags/' + params.id + '/update-weight', {...params}, {singleRequest: true}),
};
